//uneeded for now

// import React from 'react';
// import { Link, useLocation } from 'react-router-dom';
// import useAuth from '../../hooks/useAuth';
// import useChat from '../../hooks/useChat';

// /**
//  * Sidebar component with navigation links
//  * @returns {JSX.Element} Sidebar component
//  */
// const Sidebar = () => {
//   const { user, isAuth } = useAuth();
//   const { unreadCount } = useChat();
//   const location = useLocation();
  
//   // Check if a link is active
//   const isActive = (path) => {
//     if (path === '/') {
//       return location.pathname === '/';
//     }
//     return location.pathname.startsWith(path);
//   };
  
//   // Navigation links
//   const navLinks = [
//     {
//       name: 'Home',
//       path: '/',
//       icon: (
//         <svg
//           className="h-6 w-6"
//           xmlns="http://www.w3.org/2000/svg"
//           fill="none"
//           viewBox="0 0 24 24"
//           stroke="currentColor"
//         >
//           <path
//             strokeLinecap="round"
//             strokeLinejoin="round"
//             strokeWidth={2}
//             d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
//           />
//         </svg>
//       ),
//     },
//     {
//       name: 'Explore',
//       path: '/explore',
//       icon: (
//         <svg
//           className="h-6 w-6"
//           xmlns="http://www.w3.org/2000/svg"
//           fill="none"
//           viewBox="0 0 24 24"
//           stroke="currentColor"
//         >
//           <path
//             strokeLinecap="round"
//             strokeLinejoin="round"
//             strokeWidth={2}
//             d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
//           />
//         </svg>
//       ),
//     },
//     {
//       name: 'Communities',
//       path: '/communities',
//       icon: (
//         <svg
//           className="h-6 w-6"
//           xmlns="http://www.w3.org/2000/svg"
//           fill="none"
//           viewBox="0 0 24 24"
//           stroke="currentColor"
//         >
//           <path
//             strokeLinecap="round"
//             strokeLinejoin="round"
//             strokeWidth={2}
//             d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
//           />
//         </svg>
//       ),
//     },
//   ];
  
//   // Auth-required links
//   const authLinks = [
//     {
//       name: 'Profile',
//       path: user ? `/profile/${user.username}` : '/profile',
//       icon: (
//         <svg
//           className="h-6 w-6"
//           xmlns="http://www.w3.org/2000/svg"
//           fill="none"
//           viewBox="0 0 24 24"
//           stroke="currentColor"
//         >
//           <path
//             strokeLinecap="round"
//             strokeLinejoin="round"
//             strokeWidth={2}
//             d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
//           />
//         </svg>
//       ),
//     },
//     {
//       name: 'Messages',
//       path: '/chat',
//       icon: (
//         <svg
//           className="h-6 w-6"
//           xmlns="http://www.w3.org/2000/svg"
//           fill="none"
//           viewBox="0 0 24 24"
//           stroke="currentColor"
//         >
//           <path
//             strokeLinecap="round"
//             strokeLinejoin="round"
//             strokeWidth={2}
//             d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z"
//           />
//         </svg>
//       ),
//       badge: unreadCount > 0 ? unreadCount : null,
//     },
//     {
//       name: 'Notifications',
//       path: '/notifications',
//       icon: (
//         <svg
//           className="h-6 w-6"
//           xmlns="http://www.w3.org/2000/svg"
//           fill="none"
//           viewBox="0 0 24 24"
//           stroke="currentColor"
//         >
//           <path
//             strokeLinecap="round"
//             strokeLinejoin="round"
//             strokeWidth={2}
//             d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"
//           />
//         </svg>
//       ),
//     },
//     {
//       name: 'Bookmarks',
//       path: '/bookmarks',
//       icon: (
//         <svg
//           className="h-6 w-6"
//           xmlns="http://www.w3.org/2000/svg"
//           fill="none"
//           viewBox="0 0 24 24"
//           stroke="currentColor"
//         >
//           <path
//             strokeLinecap="round"
//             strokeLinejoin="round"
//             strokeWidth={2}
//             d="M5 5a2 2 0 012-2h10a2 2 0 012 2v16l-7-3.5L5 21V5z"
//           />
//         </svg>
//       ),
//     },
//     {
//       name: 'Settings',
//       path: '/settings',
//       icon: (
//         <svg
//           className="h-6 w-6"
//           xmlns="http://www.w3.org/2000/svg"
//           fill="none"
//           viewBox="0 0 24 24"
//           stroke="currentColor"
//         >
//           <path
//             strokeLinecap="round"
//             strokeLinejoin="round"
//             strokeWidth={2}
//             d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"
//           />
//           <path
//             strokeLinecap="round"
//             strokeLinejoin="round"
//             strokeWidth={2}
//             d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
//           />
//         </svg>
//       ),
//     },
//   ];
  
//   return (
//     <div className="sticky top-0 py-4 pr-4 overflow-y-auto bg-white border-r border-gray-200 hidden md:block" style={{height: 'calc(100vh - 65px)'}}>
//       <div className="flex flex-col h-full">
        
//         <nav className="flex-1 space-y-1">
//           {/* Main navigation links */}
//           {navLinks.map((link) => (
//             <Link
//               key={link.name}
//               to={link.path}
//               className={`flex items-center px-4 py-3 text-gray-700 rounded-lg ${
//                 isActive(link.path)
//                   ? 'bg-blue-50 text-blue-700 font-medium'
//                   : 'hover:bg-gray-100'
//               }`}
//             >
//               <span
//                 className={`${
//                   isActive(link.path) ? 'text-blue-600' : 'text-gray-500'
//                 }`}
//               >
//                 {link.icon}
//               </span>
//               <span className="ml-3">{link.name}</span>
//             </Link>
//           ))}
          
//           {/* Auth-required links */}
//           {isAuth && (
//             <>
//               <div className="pt-4 pb-2">
//                 <div className="border-t border-gray-200"></div>
//               </div>
              
//               {authLinks.map((link) => (
//                 <Link
//                   key={link.name}
//                   to={link.path}
//                   className={`flex items-center px-4 py-3 text-gray-700 rounded-lg ${
//                     isActive(link.path)
//                       ? 'bg-blue-50 text-blue-700 font-medium'
//                       : 'hover:bg-gray-100'
//                   }`}
//                 >
//                   <span
//                     className={`${
//                       isActive(link.path) ? 'text-blue-600' : 'text-gray-500'
//                     }`}
//                   >
//                     {link.icon}
//                   </span>
//                   <span className="ml-3">{link.name}</span>
//                   {link.badge && (
//                     <span className="ml-auto bg-red-500 text-white text-xs font-semibold rounded-full h-5 w-5 flex items-center justify-center">
//                       {link.badge > 9 ? '9+' : link.badge}
//                     </span>
//                   )}
//                 </Link>
//               ))}
//             </>
//           )}
//         </nav>
        
//         {/* Post button for authenticated users */}
//         {isAuth && (
//           <div className="mt-6 px-4">
//             <Link
//               to="/"
//               className="w-full inline-flex justify-center items-center px-4 py-3 border border-transparent text-sm font-medium rounded-full shadow-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
//             >
//               Create Post
//             </Link>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default Sidebar;